export default "__VITE_ASSET__Ba0Kx5Fq__"